export const formatPriceFraction = (
    amount: number,
    fractionDigits: number
): number => amount / 10 ** fractionDigits;
